import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useEffect } from 'react';
import SnackBar from '../General/SnackBar';
import ConfirmationDialog from './ConfirmationDialog';
import { PostEditData } from 'API/Procurement/VendorApis';
import BackdropLoader from '../General/Loader';

export default function EditModal(props) {
  const [ActiveStep, setActiveStep] = useState(0);

  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState('success');
  const [OpenAlert, setOpenAlert] = useState(false);

  const [EditData, setEditData] = useState(null);

  const [OpenConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);

  const handleVendorCodeChange = (item, e) => {
    console.log('change.........');

    if (new RegExp(item.pattern).test(e.target.value)) {
      if (item.name === 'mobile_number' && e.target.value.length <= 10) {
        setEditData({ ...EditData, [item.name]: e.target.value });
      } else if (item.name !== 'mobile_number') {
        setEditData({ ...EditData, [item.name]: e.target.value });
      }
    }
  };

  // const handleNext = () => {
  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const GeneralForm = [
    { name: 'vendor_code', lable: 'Vendor Code', type: 'text', pattern: '^[a-zA-Z0-9]*$' },
    { name: 'vendor_name', lable: 'Vendor Name', type: 'text', pattern: '^[a-zA-Z ]*$' },
    { name: 'company_name', lable: 'Company Name', type: 'text', pattern: '^[a-zA-Z ]*$' },
    { name: 'dob', lable: 'Dob', type: 'date' },
    { name: 'pan_card_no', lable: 'Pan Number', type: 'vertfy', pattern: '^[a-zA-Z0-9]*$' },
    { name: 'mobile_number', lable: 'Mobile Number', type: 'text', pattern: '^[0-9]*$' },
    { name: 'email_address', lable: 'Email Address', type: 'text', pattern: '^[a-zA-Z0-9@._]*$' },
    { name: 'mobile_number_2', lable: 'Alternate Number', type: 'text', pattern: '^[0-9]*$' },
    { name: 'address', lable: 'Address', type: 'text', pattern: '^[a-zA-Z0-9/., ]*$' },
    { name: 'pin_code', lable: 'Pincode', type: 'text', pattern: '^[0-9]*$' },
    { name: 'district', lable: 'District', type: 'text', pattern: '^[a-zA-Z ]*$', disabled: true },
    { name: 'sub_district', lable: 'Sub District', type: 'text', pattern: '^[a-zA-Z ]*$', disabled: true },
    { name: 'city_name', lable: 'City or Town', type: 'text', pattern: '^[a-zA-Z ]*$' }
  ];

  const AccountForm = [
    { name: 'gst_number', lable: 'GST Number', type: 'text', pattern: '^[0-9A-Z]*$' },
    { name: 'bank_name', lable: 'Bank Name', type: 'text', pattern: '^[a-zA-Z ]*$' },
    { name: 'ifsc_code', lable: 'IFSC Code', type: 'text', pattern: '^[a-zA-Z0-9]*$' },
    { name: 'bank_account_number', lable: 'Current Account Number', type: 'verify', pattern: '^[0-9]*$' },
    { name: 'bank_account_name', lable: 'Bank Account Name', type: 'text', pattern: '^[a-zA-Z ]*$', disabled: true }
  ];

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setOpenAlert(true);
  };

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const HandlePostData = () => {
    PostEditData(props.data, EditData, setIsLoading, props.handleClose, handleAlertOpen, props.handleSearch);
  };

  useEffect(() => {
    setEditData(null);
    setActiveStep(0);
    handleCloseConfirmDialog();
  }, [props.open]);

  const handleSubmit = () => {
    if (!EditData) {
      handleAlertOpen('No changes have been made for the vendor', 'error');
    } else {
      if (EditData.mobile_number && EditData.mobile_number.length < 10) {
        handleAlertOpen('Mobile number should be 10 digits long', 'error');
        return;
      } else {
        handleOpenConfirmDialog();
      }
    }
  };

  // useEffect(()=>{
  //     handleAlertOpen("hello","success")
  // },[])

  // console.log("asasd",EditData);

  return (
    <React.Fragment>
      <BackdropLoader open={IsLoading} />
      <SnackBar open={OpenAlert} type={AlertType} message={AlertMessage} handleClose={handleAlertClose} />
      <ConfirmationDialog open={OpenConfirmDialog} handleClose={handleCloseConfirmDialog} handleSubmit={HandlePostData} />
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="lg"
      >
        <DialogContent>
          <Box sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', fontSize: '25px' }} onClick={props.handleClose}>
            <IoClose />
          </Box>

          {ActiveStep === 0 ? (
            <>
              <Typography variant="h4" mb={1}>
                Basic Details
              </Typography>
              <Grid container spacing={2}>
                {props.data &&
                  GeneralForm.map((item, index) =>
                    item.type === 'text' ? (
                      <Grid item key={index} xl={4} lg={4} md={12} xs={12}>
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label={item.lable}
                          variant="outlined"
                          onChange={(e) => handleVendorCodeChange(item, e)}
                          sx={{
                            input: {
                              background:
                                item.name === 'address' || item.name === 'mobile_number' || item.name === 'email_address'
                                  ? '#FFFFF2'
                                  : '#f2f2f2'
                            }
                          }}
                          inputProps={{
                            contentEditable:
                              item.name === 'address' || item.name === 'mobile_number' || item.name === 'email_address' ? true : false
                          }}
                          value={
                            item.name === 'address' && EditData && (EditData.address || EditData.address === '')
                              ? EditData.address
                              : item.name === 'mobile_number' && EditData && (EditData.mobile_number || EditData.mobile_number === '')
                              ? EditData.mobile_number
                              : item.name === 'email_address' && EditData && (EditData.email_address || EditData.email_address === '')
                              ? EditData.email_address
                              : props.data[item.name]
                              ? props.data[item.name]
                              : props.data[item.name]
                              ? props.data[item.name]
                              : ''
                          }
                        />
                      </Grid>
                    ) : item.type === 'date' ? (
                      <Grid item key={index} xl={4} lg={4} md={12} xs={12}>
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label={item.lable}
                          variant="outlined"
                          onChange={(e) => (item.name === 'vendor_code' ? handleVendorCodeChange(e) : null)}
                          type="date"
                          sx={{
                            input: {
                              background: '#f2f2f2'
                            }
                          }}
                          inputProps={{
                            contentEditable: false
                          }}
                          value={
                            item.name === 'vendor_code'
                              ? EditData || EditData === ''
                                ? EditData
                                : props.data[item.name]
                                ? props.data[item.name]
                                : ''
                              : props.data[item.name]
                              ? props.data[item.name]
                              : ''
                          }
                        />
                      </Grid>
                    ) : null
                  )}
              </Grid>

              <Grid container spacing={2} mt={1}>
                {props.data &&
                  AccountForm.map((item, index) => (
                    <Grid item key={index} xl={4} lg={4} md={12} xs={12}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label={item.lable}
                        variant="outlined"
                        onChange={(e) => (item.name === 'vendor_code' ? handleVendorCodeChange(e) : null)}
                        sx={{
                          input: {
                            background: '#f2f2f2'
                          }
                        }}
                        inputProps={{
                          contentEditable: false
                        }}
                        value={
                          item.name === 'vendor_code'
                            ? EditData && EditData !== ''
                              ? EditData
                              : props.data[item.name]
                              ? props.data[item.name]
                              : ''
                            : props.data[item.name]
                            ? props.data[item.name]
                            : ''
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </>
          ) : (
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="h4">Documents</Typography>
                <table>
                  <tr>
                    <td>
                      <Typography variant="h5">Pancard</Typography>
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={() => handleViewFile(props.data['uploaded_file']['pan_card'])}
                      >
                        view
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="h5">GST</Typography>
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={() => handleViewFile(props.data['uploaded_file']['gst_no'])}
                      >
                        view
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="h5">Copy of Passbook/Cancelled cheque</Typography>
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={() => handleViewFile(props.data['uploaded_file']['passbook/cancelled_cheque'])}
                      >
                        view
                      </Button>
                    </td>
                  </tr>
                </table>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        {ActiveStep === 0 ? (
          <DialogActions>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={2}>
                <Button fullWidth variant="contained" color="secondary" sx={{
                        backgroundColor: '#688B3A',
                        color: '#fff',
                        borderRadius: '6px',
                        '&:hover': {
                          backgroundColor: '#688B3A'
                        }
                      }} size="medium" onClick={handleSubmit}>
                  Update
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        ) : (
          <DialogActions>
            <Grid container spacing={2} justifyContent="space-between" padding={3}>
              <Grid item xs={2}>
                <Button autoFocus={false} fullWidth variant="contained" size="small" color="secondary" onClick={handleBack}>
                  Back
                </Button>
              </Grid>
              {props.type === 'pending' ? (
                <Grid item xs={4}>
                  <Stack gap={1} direction="row">
                    <Button
                      autoFocus={false}
                      fullWidth
                      variant="contained"
                      size="small"
                      color="success"
                      onClick={() => handleOpenConfirmDialog('approved')}
                    >
                      Approve
                    </Button>
                    <Button
                      autoFocus={false}
                      fullWidth
                      variant="contained"
                      size="small"
                      color="error"
                      onClick={() => handleOpenConfirmDialog('rejected')}
                    >
                      Reject
                    </Button>
                  </Stack>
                </Grid>
              ) : null}
            </Grid>
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
}
